import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { IRoomStreaming } from '../../../redux/streamGoApi';
import {
  StreamingContainer,
  StreamingItem,
  StreamingItemHeader,
  StreamingItemTitle,
  StreamingItemActions,
  StreamingItemDetails,
} from './styled';

export interface IStreamingUrlList {
  onDelete: (index: number) => () => void;
  onEdit: (index: number) => () => void;
  streamings: IRoomStreaming[];
}

export const StreamingUrlList = ({
  onDelete,
  onEdit,
  streamings,
}: IStreamingUrlList) => {
  if (streamings.length === 0) {
    return null;
  }

  return (
    <StreamingContainer>
      {streamings.map((streaming, index) => (
        <StreamingItem key={index}>
          <StreamingItemHeader>
            <StreamingItemTitle>{streaming.Description}</StreamingItemTitle>
            <StreamingItemActions>
              <IconButton
                onClick={onEdit(index)}
                size="small"
                sx={{ color: '#44c0b9', padding: '4px' }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton
                onClick={onDelete(index)}
                size="small"
                sx={{ color: '#ff4444', padding: '4px' }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </StreamingItemActions>
          </StreamingItemHeader>
          <StreamingItemDetails>
            <div>
              <strong>Streaming URL:</strong> {streaming.StreamingUrl}
            </div>
            {streaming.StreamingKey && (
              <div>
                <strong>Streaming Key:</strong>{' '}
                {streaming.StreamingKey.substring(0, 20)}
              </div>
            )}
          </StreamingItemDetails>
        </StreamingItem>
      ))}
    </StreamingContainer>
  );
};
